import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/validate/validate-remove.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import { getNode } from "../../classifier-service";
import { isReferenceNode, isUserClassifierGroupNode, isUserClassifierGroupWithElementsNode, isUserClassifierGroupWithGroupsNode } from "../../classifier-service/Node";
export function validateToRemove(params) {
  var toDeleteAllItems = params.items.filter(function (item) {
    var node = getNode(params.nodes, item);

    if (!allowToDelete.is(item.type) || !node) {
      return;
    }

    if ((isUserClassifierGroupNode(node) || isReferenceNode(node)) && allowToDelete.isInDirectRef(node)) {
      return;
    }

    return node;
  });
  var disabledTitle = params.items.length > toDeleteAllItems.length ? 'Нельзя удалять элементы и папки из перенесенной иерархии' : '';
  var toDeleteGroups = toDeleteAllItems.reduce(function (acc, next) {
    var node = getNode(params.nodes, next);
    return node && (isUserClassifierGroupWithElementsNode(node) || isUserClassifierGroupWithGroupsNode(node)) ? [].concat(_toConsumableArray(acc), [node.name]) : acc;
  }, []);
  return {
    disabledTitle: disabledTitle,
    toDeleteAllItems: toDeleteAllItems,
    toDeleteGroups: toDeleteGroups
  };
}
export var allowToDelete;

(function (_allowToDelete) {
  var allowTypes = ['UserClassifierGroupWithGroupsNode', 'UserClassifierGroupWithElementsNode', 'UserClassifierEmptyGroupNode', 'BimStandardSizeReferenceNode', 'BimCategoryReferenceNode', 'BimFamilyReferenceNode', 'BimElementReferenceNode', 'BimModelReferenceNode'];

  function is(value) {
    return allowTypes.includes(value);
  }

  _allowToDelete.is = is;

  function isInDirectRef(node) {
    var _node$source;

    return ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.relationType) === 'Indirect';
  }

  _allowToDelete.isInDirectRef = isInDirectRef;
})(allowToDelete || (allowToDelete = {}));